import './ChangeAvatar.less';
import { Upload, message, Button } from 'antd';
import ImgCrop from 'antd-img-crop';
const { Dragger } = Upload;
import type { UploadProps } from 'antd';
import { useTranslation } from 'react-i18next';
import Avatar from 'assets/images/liHome/Avatar.svg';
import { getConfig } from 'configs';
import { useKeycloak } from 'all-in-one-react-keycloak';
// import { useState } from 'react';
const ChangeAvatar = (changeAvatarProps: { sendModalStatus: () => void; sendAvatarStatus: () => void }) => {
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();
  const { baseApiUrl } = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'development');
  // const [visible, setVisible] = useState(false);
  const uploadProfileAvatarUrl = `${baseApiUrl}/xapi/v1/user/setting/life-profile-image`;
  const props: UploadProps = {
    name: 'file',
    action: uploadProfileAvatarUrl,
    headers: {
      authorization: 'Bearer ' + keycloak.token,
      accept: 'application/json',
    },
    showUploadList: false,
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
        changeAvatarProps.sendModalStatus();
        changeAvatarProps.sendAvatarStatus();
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };
  // const handleModalCancel = () => {
  //   console.log(111);
  //   setVisible(false);
  // };
  const imgCropProps = {
    width: 185, //裁剪宽度
    height: 185, //裁剪高度
    quality: 1, //裁切图像质量，0到1之间
    fillColor: 'white', // 裁切图像填充色
    resize: false, //裁剪是否可以调整大小
    zoomSlider: true, // 是否缩放
    rotationSlider: true, // 旋转调节
    aspectSlider: false, // 纵横调节
    // showReset: true, // 重置按钮展示
    // resetText: '重置', // 重置按钮文本
    aspect: 1, // 宽高比
    // minZoom: 1, // 最小变焦系数
    // maxZoom: 3, // 最大变焦系数
    showGrid: true, // 裁剪框网格
    resizeAndDrag: true, //裁剪是否可以调整大小、可拖动
    modalWidth: 510, //弹窗宽度
    // cropShape: 'round', // 裁剪框是圆形还是方形 圆形:round 方形:rect (这个属性放到这里面不好使)
    // onModalOk: props.onChange, // 确定裁剪回调
    // onModalCancel: handleModalCancel, // 取消裁剪回调
    // beforeCrop: this.beforeCrop, // 裁剪前回调 如果返回false或reject()则停止裁剪
    // modalProps: {
    //   open: visible,
    //   footer: (
    //     <>
    //       <p className="choose">{t('life.lifeProfile.or')}</p>
    //       <div>
    //         <Button className="Save" onClick={handleModalCancel}>
    //           {t('life.lifeProfile.Save')}
    //         </Button>
    //         <Button className="cancel" onClick={handleModalCancel}>
    //           {t('life.lifeProfile.Cancel')}
    //         </Button>
    //       </div>
    //     </>
    //   ),
    // },
  };

  return (
    <>
      <ImgCrop
        cropShape="round"
        modalTitle={t('profile.profilePicture.editImage')}
        modalOk={t('life.lifeProfile.Save')}
        modalCancel={t('life.lifeProfile.SelectPhotoAgain')}
        beforeCrop={(file) => {
          return !!file;
        }}
        modalClassName="img-crop-wrapper"
        {...imgCropProps}
      >
        <Dragger {...props} className="drag-avatar">
          <p className="ant-upload-drag-icon">
            <img src={Avatar} alt="" />
          </p>
          <p className="ant-upload-text">{t('life.lifeProfile.draghere')}</p>
        </Dragger>
      </ImgCrop>
      <p className="choose">{t('life.lifeProfile.or')}</p>
      <div className="click-upload">
        <ImgCrop
          cropShape="round"
          modalTitle={t('profile.profilePicture.editImage')}
          modalOk={t('common.ok')}
          modalCancel={t('common.cancel')}
          beforeCrop={(file) => {
            return !!file;
          }}
          {...imgCropProps}
        >
          <Upload {...props}>
            <Button className="upload">{t('life.lifeProfile.select')}</Button>
          </Upload>
        </ImgCrop>
        <Button className="cancel" onClick={() => changeAvatarProps.sendModalStatus()}>
          {t('life.lifeProfile.Cancel')}
        </Button>
      </div>
    </>
  );
};

export default ChangeAvatar;
